window.addEventListener('DOMContentLoaded', () => {
  $("#menu-toggle").on("click", function(e) {
    e.preventDefault();
    $("#wrapper_admin").toggleClass("toggled");
  })
});
